import $api from "@/zapi-frontend/shared/api/axios";
import type { TOrganizationProjectDimension } from "@/zapi-frontend/shared/types/projects";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { AxiosError } from "axios";
import type { TDimensionType } from "../lib/dimensionForm";

export type TUpdateProjectDimensionPayload = {
  orgId: number;
  dimensionId: number;
  name: string;
  type: TDimensionType;
  options: string[];
  color: string;
  confirmDestructive?: boolean;
};

export type TUpdateProjectDimensionConflict = {
  message: string;
  affectedCount: number;
};

export function useUpdateProjectDimension(
  options?: UseMutationOptions<
    TOrganizationProjectDimension,
    AxiosError<{ message: string; affectedCount?: number }>,
    TUpdateProjectDimensionPayload
  >
) {
  return useMutation({
    mutationKey: ["updateProjectDimension"],
    mutationFn: async ({
      orgId,
      dimensionId,
      name,
      type,
      options: opts,
      color,
      confirmDestructive
    }: TUpdateProjectDimensionPayload) => {
      const { data } = await $api.patch<{ data: TOrganizationProjectDimension }>(
        `/organizations/${orgId}/project-dimensions/${dimensionId}`,
        {
          name: name.trim(),
          type,
          options: type === "dropdown" ? opts : [],
          color,
          confirmDestructive: confirmDestructive ?? false
        }
      );
      return data.data;
    },
    ...options
  });
}
